<template>
  <div class="container welcome-student" v-check-permission="'registration-to-careers'">

    <div class="card">
      <div class="card-block">

        <div class="ex-page-content text-center">

          <h1 v-if="configItemAcademicYear">Inscripción ciclo lectivo {{ configItemAcademicYear.value }}</h1>

          <template v-if="enrolledCompleted">

            <span><i class="fa fa-smile-o icon"></i></span>
            <div class="alert alert-success mt-3">
              <h5>Estas matriculado/a</h5>
              <p>El {{registrationDate}} te inscribiste en {{registrationToCareer.level}} año de {{career.name}}</p>
            </div>

            <p class="mt-4">Si deseas reimprimir el formulario de inscripción, puedes hacer <router-link to="/print-student-registration" class="waves-effect"><span>click aquí</span></router-link>.</p>

          </template>

          <template v-else-if="approvedCompleted">

            <span><i class="fa fa-smile-o icon"></i></span>
            <div class="alert alert-success mt-3">
              <h5>Tu inscripción ha sido aprobada</h5>
              <p>El {{registrationDate}} te inscribiste en {{registrationToCareer.level}} año de {{career.name}}</p>
              <p>Puedes pagar la matricula desde la opción <router-link to="/list-user-payments" class="waves-effect"><i class="fa fa-money"></i> <span> Pagos </span> </router-link> en el menú de la izquierda.<br></p>
            </div>

            <div style="background: #ee8a8b; padding: 10px;" class="col-md 12 mb-3">
              <h5 style="color: #ffffff;">Información importante:</h5>
              <p style="color: #ffffff;">Recuerda que reservaremos tu lugar como alumno una vez que hayas finalizado con todo el circuito de inscripción, el mismo finaliza con el pago de la matricula.</p>
            </div>

            <p class="mt-4">Si deseas reimprimir el formulario de inscripción, puedes hacer <router-link to="/print-student-registration" class="waves-effect"><span>click aquí</span></router-link>.</p>

          </template>

          <template v-else-if="suspended">

            <span><i class="fa fa-smile-o icon"></i></span>
            <div class="alert alert-danger mt-3">
              <h5>Tu inscripción ha sido dada de baja</h5>
              <p>Si deseas conocer el motivo comunicate con el area de informática del Instituto.</p>
            </div>

          </template>

          <template v-else-if="configItemRegistrationToCareersIsActive">

            <span><i class="fa fa-smile-o icon"></i></span>
            <h5 class="text-muted">Para continuar con el proceso de inscripción debes completar los siguientes pasos:</h5>
            <router-link class="btn btn-primary mb-5 waves-effect waves-light go-student-registration-step-1" to="/student-registration-step-1" href="#">Comenzar</router-link>

            <div v-if="(step1Completed || step2Completed || step3Completed)">
              <p class="text-muted mt-5">O puedes retomar desde el paso en donde te quedaste la última vez:</p>
              <a class="btn btn-default mb-5 waves-effect waves-light" href="javascript:void(0);" @click="goToTheLastStep()">Retomar</a>
            </div>

            <div v-if="step3Completed" class="col-md-12 mt-5">
              <p class="mt-4">Si deseas reimprimir el formulario de inscripción, puedes hacer <router-link to="/print-student-registration" class="waves-effect"><span>click aquí</span></router-link>.</p>
            </div>

          </template>

          <template v-else>

            <span><i class="fa fa-user-times icon"></i></span>
            <h5 class="text-muted">Actualmente las inscripciones estan cerradas.</h5>

          </template>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'welcome-student',


    created () {
      // Obtenemos todas las configuraciones desde el api
      this.getAllConfigurations();
    },


    data () {
      return {
        user: this.$store.state.auth.user,
        step3Completed: false,
        step2Completed: false,
        step1Completed: false,
        enrolledCompleted: false,
        approvedCompleted: false,
        suspended: false
      }
    },


    computed: {

      registrationToCareer: function () {
        return this.$store.getters.getRegistrationToCareer
      },

      registrationDate: function () {
        return this.$moment(this.registrationToCareer.createdAt).format('DD/MM/YYYY');
      },

      // traemos la configuracion para saber el año lectivo actual
      configItemAcademicYear: function () {
        return this.$store.getters.getConfigByKey('registrationToCareers.academicYear')
      },

      career: function () {
        return this.$store.getters.getCareer
      },

      //traemos la configuracion para saber si el formulario de inscripcion a las carreras esta activo
      configItemRegistrationToCareersIsActive: function () {
        return (this.$store.getters.getConfigByKey('registrationToCareers.active') ? Boolean(this.$store.getters.getConfigByKey('registrationToCareers.active').value) : false)
      },


    },


    methods: {

      verifyStepsCompleted: function () {

        var self = this
        this.$loader.loading();

        if(self.configItemAcademicYear && self.configItemAcademicYear.value) {

          const academicYear = self.configItemAcademicYear.value;

          this.$store.dispatch('getRegistrationToCareer', { registrationToCareer: { academicYear: academicYear, user: self.user._id } })
            .then((response) => {

              if(response.data && response.data.studentRegistrationStatus) {

                if(response.data.studentRegistrationStatus != 'pending' &&
                  response.data.studentRegistrationStatus != 'pending-step-1' &&
                  response.data.studentRegistrationStatus != 'pending-step-2' &&
                  response.data.studentRegistrationStatus != '') {

                  self.step3Completed = true;

                } else if(response.data.studentRegistrationStatus != 'pending' &&
                  response.data.studentRegistrationStatus != 'pending-step-1' &&
                  response.data.studentRegistrationStatus != '') {

                  self.step2Completed = true;

                } else if(response.data.studentRegistrationStatus != 'pending' &&
                  response.data.studentRegistrationStatus != '') {

                  self.step1Completed = true;

                }

                if(response.data.studentRegistrationStatus == 'conditional-approved' ||
                  response.data.studentRegistrationStatus == 'final-approved') {

                  self.approvedCompleted = true;

                }

                if(response.data.studentRegistrationStatus == 'officially-suspended' ||
                  response.data.studentRegistrationStatus == 'suspended-ex-officio') {

                  self.suspended = true;

                }

                if(response.data.studentRegistrationStatus == 'enrolled-standard' ||
                  response.data.studentRegistrationStatus == 'enrolled-for-exams' ||
                  response.data.studentRegistrationStatus == 'enrolled-with-a-scholarship') {

                  self.enrolledCompleted = true;

                }

              }

              this.$loader.close();
            })
            .catch((response) => {

              this.$loader.close();
              this.$message.error({text: response.message});

            })
        }
      },


      goToTheLastStep: function () {

        var self = this

        if(self.step3Completed) {

          self.$router.push('/print-student-registration/')

        } else if(self.step2Completed) {

          self.$router.push('/student-registration-step-3')

        } else if(self.step1Completed) {

          self.$router.push('/student-registration-step-2')

        }

      },


      getAllConfigurations: function () {
        this.$loader.loading();

        this.$store.dispatch('getAllConfigurations')
          .then((response) => {
            this.$loader.close();
            this.verifyStepsCompleted();
            this.getCareer();
          })
          .catch((response) => {
            this.$loader.close();
            this.$message.error({text: response.message});
          })

      },


      getCareer: function () {
        var self = this;
        this.$loader.loading();

        if(this.registrationToCareer) {
          this.$store.dispatch('getCareer', {id: self.registrationToCareer.career._id})
            .then((response) => {

              this.$loader.close();
            })
            .catch((response) => {

            this.$loader.close();
            this.$message.error({text: response.message});

          })
        }
      }

    }
  }
</script>

<style scoped>
  h1 {
    font-size: 3em;
    line-height: normal;
    text-shadow: none;
  }
  .icon {
    font-size: 47px;
  }
  .card {
    min-height: 80vh;
  }
  .go-student-registration-step-1, .btn-primary {
    margin-top: 20px;
  }
  .ex-page-content {
    margin-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/WelcomeRegistrationToCareers.vue